module.exports = __webpack_public_path__ + "img/shield-protected.c5ab8075.svg";